export default __webpack_public_path__ + "static/media/SamanthaBird.45a73a86.png";